import { calcCellSize } from './calcCellSize';
import { calcGridPos } from './calcGridPos';
export function calcSlicesRect() {
    var cellSize = calcCellSize();
    var gridPos = calcGridPos(cellSize);
    var gridSize = cellSize * 9;
    var y = gridSize + gridPos.y + 10;
    return { x: gridPos.x, y: y, w: gridSize, h: window.innerHeight - y - 10 };
}
